import Button from 'react-bootstrap/Button';
import * as icons from 'react-bootstrap-icons'; // typing only

import { Icon } from "../../react-entry";

const IconButton = (props: {
    iconName: keyof typeof icons,
    label: string,
    href: string,
    title?: string,
}) =>
{
    return (
        <Button
            href={props.href}
            target="_blank"
            variant="default" // TODO: primary
            className="me-1" // margin left == “end”
            title={props.title}
        >
            <Icon
                iconName={props.iconName}
                className="me-2"
            />
            {props.label}
        </Button>
    );
};

export { IconButton };
